import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import moment from 'moment';
import { arrayMove, SortableContainer } from 'react-sortable-hoc';

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as resolutiondetails from '../../../actions/resolutiondetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as fileupload from '../../../actions/fileupload';
import * as lookupMeetingList from '../../../actions/meetingdetails';
import * as toaster from '../../../actions/toaster';

import MUISelector from "../../muiselector";
import SelectColor from '../../selectcolor'
import TableCell from './tablecell';

import { map, remove, union } from 'lodash'
import * as regData from '../../../../appConstants'

class AddResolution extends Component {

    constructor(props) {
        super(props);
        this.state = {
            setValue: false,
            isFileUploaded: false,
            committee_id: Number(this.props.loginUser.data.committee_id),
            id: this.props.params.id,
            resolution: { id: '', committee_id: '', headedBy: '', color: '', name: '', closevote: moment().format('YYYY-MM-DD'), description: '', supermeetingId: '', description: '', resolutionFiles: [], resolutionUser: [], committee_user: [] },
            newfile: '',
        };
    }

    componentDidMount() {
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            this.props.actions.getResolutionDetails(this.state.id);
        }
        else
            this.state.resolution = { id: '', committee_id: '', headedBy: '', color: '', name: '', closevote: moment().format('YYYY-MM-DD'), description: '', supermeetingId: '', description: '', resolutionFiles: [], resolutionUser: [], committee_user: [] }
        this.props.actions.loadswitchercommittees();
        this.props.actions.getTeamUserList(this.props.loginUser.data.committee_id);
        this.props.actions.lookupMeetingList(this.props.loginUser.data.committee_id);
    }

    handleChange(field, e) {

        if (field == "filedescription") {
            const newfile = Object.assign({}, this.state.newfile, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'newfile': newfile }));
        }
        else if (field == 'closevote') {
            // console.log(field, moment(e).format('DD-MM-YYYY'))
            let resolution = Object.assign({}, this.state.resolution, { [field]: moment(e).format('YYYY-MM-DD') });
            this.setState(Object.assign({}, this.state, { 'resolution': resolution }));
        }
        else {
            const resolution = Object.assign({}, this.state.resolution, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'resolution': resolution }));
        }
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.props.actions.getTeamUserList(e.target.value);
        this.props.actions.lookupMeetingList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    getUpdateFileDetails = (data) => {
        // Find item index using _.findIndex
        var index = _.findIndex(this.state.resolution.resolutionFiles, { fileId: data.fileId });
        // Replace item at index using native splice
        this.state.resolution.resolutionFiles.splice(index, 1, data);
        this.setState({ 'setValue': true });
    }
    getDeleteFileDetails = (data) => {
        if (data && data.fileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.resolution.resolutionFiles, { fileId: data.fileId });
            // Replace item at index using native splice
            this.state.resolution.resolutionFiles.splice(index, 1);
        }
        else if (data && data.tempFileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.resolution.resolutionFiles, { tempFileId: data.tempFileId });
            // Replace item at index using native splice
            this.state.resolution.resolutionFiles.splice(index, 1);
        }
        this.setState({ 'setValue': true });
    }
    handleFileSelected(file) {
        let filedescription = this.state.newfile.filedescription ? this.state.newfile.filedescription : ''
        let newfile = { 'filedescription': filedescription, 'file': file.target.files[0] }
        this.setState({ 'newfile': newfile });
        // console.log(this.state)
        let formData = new FormData();
        formData.append('file', newfile.file)
        this.props.actions.fileUpload(formData)
        this.setState({ isFileUploaded: true });
        if (this.refs.fileUpload)
            this.refs.fileUpload.value = null;
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(this.state.resolution)
        if (!this.state.resolution.supermeetingId || this.state.resolution.supermeetingId == '')
            this.props.actions.errorToasters("Please select a Meeting");
        else {
            if (this.state.resolution.id) {
                // console.log(this.state.resolution)
                this.props.actions.updateResolutionDetails(this.state.resolution);
            }
            else {
                // this.state.resolution.resolutionUser = filter(this.state.resolution.resolutionUser, { status: true })
                this.state.resolution.committee_id = this.state.committee_id;
                this.props.actions.addResolutionDetails(this.state.resolution);
            }
        }
    }

    onSortEnd = ({ oldIndex, newIndex, collection }) => {
        if (oldIndex != newIndex) {
            // console.log(oldIndex, newIndex, collection)
            let id = this.state.resolution.resolutionFiles[oldIndex].id

            const resolution = Object.assign({}, this.state.resolution, { 'resolutionFiles': arrayMove(this.state.resolution.resolutionFiles, oldIndex, newIndex) });
            this.setState({ resolution: resolution, });
            // this.props.actions.updateUserOrder(id, newIndex + 1);
        }
    };
    render() {
        const { match, loginUser, resolutionDetails, params, teamDetails, meetingDetails, fileupload } = this.props;
        // console.log('resolutionDetails', this.state.resolution)
        let result = null;
        if ((resolutionDetails && resolutionDetails.Status) || (teamDetails && teamDetails.Status) || (fileupload && fileupload.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (resolutionDetails && resolutionDetails.resolutiondetails && !this.state.setValue) {
            this.state.resolution = resolutionDetails.resolutiondetails;
            this.state.setValue = true;
            let committee_user = this.state.resolution.committee_user;
            let resolutionUser = this.state.resolution.resolutionUser;
            map(resolutionUser, function (el) {
                remove(committee_user, { 'id': el.id })
            });
            this.state.resolution.resolutionUser = union(resolutionUser, committee_user);
            // console.log('fileuser',this.state.document.resolutionUser);
        }
        else if (!this.state.id && teamDetails && teamDetails.teamuserList && teamDetails.apiGetResult)
            this.state.resolution.resolutionUser = teamDetails.teamuserList;

        if (fileupload && fileupload.filedetails && this.state.isFileUploaded) {
            // console.log('After upload success',this.state.newfile)
            fileupload.filedetails.description = this.state.newfile.filedescription;
            if (!this.state.resolution.resolutionFiles)
                this.state.resolution.resolutionFiles = [];
            this.state.resolution.resolutionFiles.push(fileupload.filedetails);
            this.state.newfile.filedescription = ''
            this.setState({ isFileUploaded: false, newfile: '' });

            // console.log('After upload success', this.state.resolution)
        }

        let _TeamList = null
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }

        let _fileList = null
        const fileList = this.state.resolution.resolutionFiles;
        if (fileList && fileList.length > 0) {
            _fileList = fileList.map((_data, index) => {
                return (<TableCell key={index} data={_data} index={index ? index : 0} getUpdateFileDetails={this.getUpdateFileDetails.bind(this)}
                    id={this.state.resolution.id} getDeleteFileDetails={this.getDeleteFileDetails.bind(this)} />);
            })
        }

        const FileSortableList = SortableContainer(({ fileList }) => {
            if (fileList == false)
                return (<tbody></tbody>)
            return (
                <tbody>
                    {fileList.map((file, index) => {
                        console.log('tbl', index)
                        // <SortableUser key={index} index={index} user={user} />
                        return < TableCell key={index} data={file} tblIndex={index} getUpdateFileDetails={this.getUpdateFileDetails.bind(this)}
                            id={this.state.resolution.id} getDeleteFileDetails={this.getDeleteFileDetails.bind(this)} />
                    })}
                </tbody>
            );
        });

        let _meetingList = null
        const meetingList = meetingDetails.switchmeetingdetailsList;
        if (meetingList && meetingList.length > 0) {
            _meetingList = meetingList.map(_mdata => (
                <MenuItem key={_mdata.smeetingId} value={_mdata.smeetingId}
                    style={{ fontWeight: '500' }}>
                    {_mdata.meetingName}
                </MenuItem>
            ))
        }
        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Add Resolution" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <FormControl className="w-100 mb-2 col-md-3">
                            <InputLabel htmlFor="age-simple">Team Switcher</InputLabel>
                            <Select
                                value={this.state.committee_id}
                                onChange={this.handleChangeTeam.bind(this)}
                                input={<Input id="age-simple" />}
                                disabled={this.state.id ? true : false}
                            >
                                {_TeamList}
                            </Select>
                        </FormControl>
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">Resolution Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-12 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="name" label="Resolution Name"
                                                validators={['required', regData.regexExp, regData.regexExpLength]}
                                                errorMessages={['This field is required', regData.messageRegexEx, regData.messageLength]}
                                                value={this.state.resolution.name} onChange={this.handleChange.bind(this, 'name')} />
                                        </div>
                                        <div className="col-12 pb-4">
                                            <MUISelector userList={this.state.resolution.resolutionUser} />
                                        </div>
                                        <div className="col-4 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="headedBy" label="Headed By"
                                                validators={[regData.regexAlphaNumeric, regData.regexAlphaNumericLength]}
                                                errorMessages={[regData.messageAlphaNumeric, regData.messageLength]}
                                                value={this.state.resolution.headedBy} onChange={this.handleChange.bind(this, 'headedBy')} />
                                        </div>
                                        <div className="col-4 pb-4">
                                            <FormControl className="w-100 mb-2 col-12">
                                                <InputLabel htmlFor="age-simple">Meeting Name</InputLabel>
                                                <Select value={Number(this.state.resolution.supermeetingId ? this.state.resolution.supermeetingId : 0)}
                                                    onChange={this.handleChange.bind(this, 'supermeetingId')}
                                                    input={<Input id="age-simple" />} >
                                                    {_meetingList}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-4 pb-4">
                                            <FormControl className="w-100 mb-2 col-12">
                                                <InputLabel htmlFor="age-simple">Color Code</InputLabel>
                                                <SelectColor value={this.state.resolution.color ? this.state.resolution.color : ''} handleChange={this.handleChange.bind(this, 'color')} />
                                            </FormControl>
                                        </div>
                                        <div className="col-4 pb-4">
                                            <DatePicker fullWidth value={this.state.resolution.closevote ? moment(this.state.resolution.closevote) : moment()}
                                                onChange={this.handleChange.bind(this, 'closevote')}
                                                animateYearScrolling={false} label="Close Date"
                                                format="DD/MM/YYYY"
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                        </div>
                                        <div className="col-12 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                name="description" label="Description" multiline={true}
                                                validators={[regData.regexMultiLineExp, regData.regexMultiLineExpLength]}
                                                errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                value={this.state.resolution.description} onChange={this.handleChange.bind(this, 'description')} />
                                        </div>
                                    </div>

                                    <Card className="shadow border-2">
                                        <CardBody>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h3 className="card-title">File Details</h3>
                                                </div>
                                                {this.state.id ? null :
                                                    <div className="col-md-8">
                                                        <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                            name="filedescription" label="File Description" multiline={true}
                                                            validators={[regData.regexMultiLineExp, regData.regexMultiLineExpLength]}
                                                            errorMessages={[regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                            value={this.state.newfile.filedescription} onChange={this.handleChange.bind(this, 'filedescription')} />
                                                    </div>
                                                }
                                                {this.state.id ? null :
                                                    <div className="col-4">
                                                        <input type="file" accept="application/pdf" id="fileUpload" ref="fileUpload" className="hidden" onChange={this.handleFileSelected.bind(this)} />
                                                        <label htmlFor="fileUpload">
                                                            <Button variant="raised" component="span" className="jr-btn bg-primary text-white">Choose file</Button>
                                                            <p class="pt-2">(Maximum size of the file should not exceed 100MB)</p>
                                                        </label>
                                                        <label className="m-2">{this.state.newfile && this.state.newfile.file ? this.state.newfile.file.name : ""}</label>
                                                    </div>
                                                }
                                                <div className="col-md-12">
                                                    <div className="table-responsive-material">
                                                        <table className="default-table table-unbordered table table-lg table-hover">
                                                            <thead className="th-border-b">
                                                                <tr>
                                                                    {/* <th>Sort</th> */}
                                                                    <th>S.No.</th>
                                                                    <th>File Name</th>
                                                                    <th>Description</th>
                                                                    <th className="status-cell text-right">Actions</th>
                                                                    <th />
                                                                </tr>
                                                            </thead>
                                                            {/* <tbody> */}
                                                            {/* {_fileList} */}
                                                            <FileSortableList fileList={this.state.resolution.resolutionFiles}
                                                                onSortEnd={this.onSortEnd} useDragHandle={true} useDragHandle={true} />
                                                            {/* </tbody> */}
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                {this.state.id ? null :
                                    <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                }
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/resolution/resolution-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { loginUser, teamDetails, meetingDetails, resolutionDetails, fileupload } = state;
    const { match } = ownProps;
    return { match, loginUser, teamDetails, meetingDetails, resolutionDetails, params: ownProps.match.params, fileupload }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, loadswitchercommittees, fileupload, lookupMeetingList, resolutiondetails, toaster), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddResolution));



// WEBPACK FOOTER //
// ./app/resolutiondetails/addresolution/index.js